var React = require('react');

function CloseGray (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"22","height":"22","rx":"11","fill":"#6B7280","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M5.98353 5.16875C6.20852 4.94375 6.57331 4.94375 6.7983 5.16875L11 9.37044L15.2017 5.16875C15.4267 4.94375 15.7915 4.94375 16.0165 5.16875L16.8313 5.98353C17.0562 6.20852 17.0562 6.57331 16.8313 6.7983L12.6296 11L16.8313 15.2017C17.0562 15.4267 17.0562 15.7915 16.8313 16.0165L16.0165 16.8313C15.7915 17.0562 15.4267 17.0562 15.2017 16.8313L11 12.6296L6.7983 16.8313C6.57331 17.0562 6.20852 17.0562 5.98353 16.8313L5.16875 16.0165C4.94375 15.7915 4.94375 15.4267 5.16875 15.2017L9.37044 11L5.16875 6.7983C4.94375 6.57331 4.94375 6.20852 5.16875 5.98353L5.98353 5.16875Z","fill":"#FAFAFC","key":1})]);
}

CloseGray.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22","fill":"none"};

module.exports = CloseGray;

CloseGray.default = CloseGray;
